import helper from '@/libs/forms';


export default {
  schema: {
    fields: [
      helper.email('Email', 'email', null, true, 12),
    ],
  },
  options: helper.options('email-confirmation-', false),
};



// WEBPACK FOOTER //
// ./src/components/auth/forgot_pass/schemas/email.js